module.exports = __webpack_public_path__ + "397e30d3485d5e24a8af2666cd23784b.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/rock.png
// module id = gUYD
// module chunks = 0